import { kabobToUpperCase } from '../../../../utils/helpers';
import { matchRegion, matchSubMarket, matchProjectType, matchTotalSqFt } from './search';
import { allOptions } from './optionData';
import { regionData } from './regionData';


// Get initial list of all regions and sub-markets (before searching)
export function getInitialOptions(properties) {
    if (!properties || properties.length === 0) return null;

    const regionOptions = [];
    const subMarketOptions = [];

    properties.forEach(property => {
        // Get unique regions
        const isNotFoundRegion =
            regionOptions.findIndex(region => {
                return region.value === property.region;
            }) === -1;

        if (isNotFoundRegion){
            const region = regionData.find(item => item.value === property.region);
            
            if (region)
                regionOptions.push(region);
        }
            

        // Get unique subMarkets
        const isNotFoundSubMarket =
            subMarketOptions.findIndex(subMarket => {
                return subMarket.value === property.submarket;
            }) === -1;

        if (property.submarket && isNotFoundSubMarket)
            subMarketOptions.push({
                region: property.region,
                value: property.submarket,
                label: kabobToUpperCase(property.submarket),
                isDisabled: false,
            });
    });

    return {
        regions: [
            allOptions.region,
            ...regionOptions.sort((a, b) => a.label > b.label),
        ],
        subMarkets: [
            allOptions.subMarket,
            ...subMarketOptions.sort((a, b) => a.label > b.label),
        ],
    };
}

export function getNewFilter(name, value, label, region, filters) {
    const newFilters = filters;

    if (name === 'region') {
        if (value === 'all') {
            newFilters.region = null;
            newFilters.subMarket = null;
            newFilters.projectType = null;
            newFilters.totalSqFt = null;
            // TODO: availableSqFt?
        } else {
            newFilters.region = { value, label };
            if (newFilters.subMarket !== null && newFilters.subMarket.region !== value) {
                newFilters.subMarket = null;
            }
        }
    } else if (name === 'subMarket') {
        if (value === 'all') {
            newFilters.subMarket = null;
            newFilters.projectType = null;
            newFilters.totalSqFt = null;
            // TODO: availableSqFt?
        } else {
            newFilters.region = newFilters.region;
            newFilters.subMarket = {
                value,
                label,
                region: region,
            };
        }
    } else {
        // This will apply to projectType, totalSqFt and availableSqFt
        if (value === 'all') {
            newFilters[name] = null;
        } else {
            newFilters[name] = { value, label };
        }
    }

    return newFilters;
}

export function showAllOptions(options) {
    return options.map(option => ({ ...option, isDisabled: false }));
}

export function getNewOptions(name, value, options, availableOptions, filters) {
    const newOptions = options;

    if (name === 'region') {
        if (value === 'all') {
            newOptions.regions = showAllOptions(options.regions);
            newOptions.subMarkets = showAllOptions(options.subMarkets);
            newOptions.projectTypes = showAllOptions(options.projectTypes);
            newOptions.totalSqFts = showAllOptions(options.totalSqFts);
            // TODO: availableSqFt?
        } else {
            newOptions.subMarkets = availableOptions.subMarkets;
            newOptions.projectTypes = availableOptions.projectTypes;
            newOptions.totalSqFts = availableOptions.totalSqFts;
            // TODO: availableSqFt?
        }
    } else if (name === 'subMarket') {
        if (value === 'all') {
            if (filters.region === null) {
                newOptions.regions = showAllOptions(options.regions);
                newOptions.subMarkets = showAllOptions(options.subMarkets);
            } else {
                newOptions.regions = showAllOptions(options.regions);
                newOptions.subMarkets = options.subMarkets.map(option => ({
                    ...option,
                    isDisabled: option.value !== 'all' && option.region !== filters.region.value,
                }));
            }
            newOptions.projectTypes = showAllOptions(options.projectTypes);
            newOptions.totalSqFts = showAllOptions(options.totalSqFts);
            // TODO: availableSqFt?
        } else {
            newOptions.projectTypes = availableOptions.projectTypes;
            newOptions.totalSqFts = availableOptions.totalSqFts;
            // TODO: availableSqFt?
        }
    } else if (name === 'projectType') {
        newOptions.regions = availableOptions.regions;
        newOptions.subMarkets = availableOptions.subMarkets;
        newOptions.totalSqFts = availableOptions.totalSqFts;
        // TODO: availableSqFt?
    } else if (name === 'totalSqFt') {
        newOptions.regions = availableOptions.regions;
        newOptions.subMarkets = availableOptions.subMarkets;
        newOptions.projectTypes = availableOptions.projectTypes;
        // TODO: availableSqFt?
    } else {
        if (availableOptions) {
            newOptions.regions = availableOptions.regions;
            newOptions.subMarkets = availableOptions.subMarkets;
            newOptions.totalSqFts = availableOptions.totalSqFts;
            newOptions.projectTypes = availableOptions.projectTypes;
        } else {
            newOptions.regions = showAllOptions(options.regions);
            newOptions.subMarkets = showAllOptions(options.subMarkets);
            newOptions.projectTypes = showAllOptions(options.projectTypes);
            newOptions.totalSqFts = showAllOptions(options.totalSqFts);
        }
    }

    return newOptions;
}

export function getAvailableOptions(searchResults, allOptions) {
    if (!searchResults || searchResults.length === 0 || !allOptions) return null;

    let regionsOptions = [],
        subMarketsOptions = [],
        projectTypesOptions = [],
        totalSqFtsOptions = [];

    regionsOptions = allOptions.regions.map(region => {
        if (region.value === 'all') return region;
                
        const count = searchResults.filter(property => matchRegion(property, region.value)).length;

        return {
            value: region.value,
            label: region.label,
            isDisabled: count === 0,
        };
    });

    subMarketsOptions = allOptions.subMarkets.map(subMarket => {
        if (subMarket.value === 'all') return subMarket;

        const count = searchResults.filter(property => matchSubMarket(property, subMarket.value)).length;

        return {
            region: subMarket.region,
            value: subMarket.value,
            label: subMarket.label,
            isDisabled: count === 0,
        };
    });

    projectTypesOptions = allOptions.projectTypes.map(projectType => {
        if (projectType.value === 'all') return projectType;

        const count = searchResults.filter(property => matchProjectType(property, projectType.value)).length;

        return {
            value: projectType.value,
            label: projectType.label,
            isDisabled: count === 0,
        };
    });
    
    totalSqFtsOptions = allOptions.totalSqFts.map(totalSqFt => {
        if (totalSqFt.value === 'all') return totalSqFt;

        const count = searchResults.filter(property => matchTotalSqFt(property.rba, totalSqFt.value)).length;

        return {
            value: totalSqFt.value,
            label: totalSqFt.label,
            isDisabled: count === 0,
        };
    });

    return {
        regions: regionsOptions,
        subMarkets: subMarketsOptions,
        projectTypes: projectTypesOptions,
        totalSqFts: totalSqFtsOptions,
    };
}
